import Component from './InstagramPostTable.vue'
export default Component
